import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingService } from '@services/setting.service';
import { ToastService } from '@utils/toast.service';
import { ButtonModule } from 'primeng/button';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'robot-sidea',
  imports: [FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule, IftaLabelModule, ToggleSwitchModule, InputNumberModule, InputGroupModule, InputGroupAddonModule],
  templateUrl: './sidea.component.html',
  styleUrl: './sidea.component.scss',
})
export class RobotSideaComponent {
  private settingService = inject(SettingService);
  private toastService = inject(ToastService);

  @Input() data!: {
    id: number;
    label: string;
    cookie: string;
    requestMade: number;
    requestMadeLimit: number;
    requestIntervalLimit: number;
    status: 'ON' | 'INTERVAL' | 'OFF';
  };

  @Output() deleted = new EventEmitter<number>();

  public cookie!: string;
  public status!: boolean;
  public requestIntervalLimit!: number;
  public requestMadeLimit!: number;

  ngOnInit() {
    this.cookie = this.data.cookie;
    this.status = this.data.status === 'ON' || this.data.status === 'INTERVAL' ? true : false;
    this.requestIntervalLimit = this.data.requestIntervalLimit;
    this.requestMadeLimit = this.data.requestMadeLimit;
  }

  public switchShutdown = () => {
    let status = this.status === true ? 'ON' : 'OFF';

    this.settingService.robotSideaSwitchStatus(this.data.id, status);

    if (this.status === true) {
      this.toastService.success('Robot encendido.');
    } else {
      this.toastService.success('Robot apagado.');
    }
  };

  public setCookie = () => {
    this.settingService.robotSideaSetCookie(this.data.id, { cookie: this.cookie, requestIntervalLimit: this.requestIntervalLimit, requestMadeLimit: this.requestMadeLimit });

    this.toastService.success('Se guardaron las cookies.');
  };

  public reset = () => {
    this.settingService.robotSideaRebot(this.data.id);

    this.data.requestMade = 0;

    this.toastService.success('Se reseteo el robot.');
  };

  public delete = () => {
    this.settingService.robotSideaDelete(this.data.id);

    this.deleted.emit(this.data.id);
    this.toastService.success('Se eliminó el robot.');
  };
}
